import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const FieldLabel = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black9};

  .required {
    color: ${({ theme }) => theme.colors.red6};
  }
`;

export const SelectedAddressLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.green1};
  border: 1px solid ${({ theme }) => theme.colors.green3};
  border-radius: 6px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black9};

  .address-icon {
    color: ${({ theme }) => theme.colors.green6};
    font-size: 16px;
    flex-shrink: 0;
  }

  .address-text {
    flex: 1;
    line-height: 1.4;
  }
`;

export const MissingFieldsNote = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.black7};
  margin: 0;
  font-style: italic;
`;
